<ng-container *ngIf="affiliateUser$ | async as affiliateUser">
    <mcv-affiliate-user-view [affiliateUser]="affiliateUser"></mcv-affiliate-user-view>
</ng-container>
